export const ORDER_STATUS: Record<string, { label: string; color: "default" | "info" | "success" | "warning" | "error" }> = {
  awaiting_kyc: { label: "Ожидает KYC", color: "warning" },
  awaiting_payment: { label: "Ожидает оплату", color: "info" },
  processing: { label: "Оплата получена, обмен", color: "info" },
  paid: { label: "Оплачено", color: "success" },
  sending: { label: "Отправка…", color: "info" },
  completed: { label: "Выполнена", color: "success" },
  send_failed: { label: "Ошибка отправки", color: "error" },
  rejected: { label: "Отклонена", color: "error" },
  cancelled: { label: "Отменена клиентом", color: "default" },
  expired: { label: "Просрочена (дозакроется поздней оплатой)", color: "warning" },
};

export function orderStatus(status: string): { label: string; color: "default" | "info" | "success" | "warning" | "error" } {
  return ORDER_STATUS[status] ?? { label: status, color: "default" };
}
